import { Suspense, useContext } from 'react'

import { BankPortalContext } from 'bank-portal-context'
import { CircularProgress } from 'ui/components'

import { useGetMenuItems } from './useGetMenuItems'

export const useBPLayout = (sidebar?: JSX.Element) => {
  const { barMinimized, changeBarMinimized, layout } = useContext(BankPortalContext)
  const { menuItems, connectionsItems } = useGetMenuItems()

  const sideBar = sidebar ? <Suspense fallback={<CircularProgress centered />}>{sidebar}</Suspense> : null

  return {
    barMinimized,
    changeBarMinimized,
    layout,
    menuItems,
    connectionsItems,
    sideBar
  }
}
